import {

    SET_URGENCYDROPDOWNVALUE,
    SET_NOOFRECIPIENTDROPDOWNVALUE,
    SET_REASONCODEDROPDOWNVALUE,
    SET_SOURCEDROPDOWNVALUE,
    SET_TEMPLATEDROPDOWNVALUE,
    SET_REASONINBRIEF,
    SET_ISSENDAPPROVAL,
    SET_DLFILENAME,
    SET_ISADDTEMPLATE,
    SET_SELECTEDDLFILE,
    SET_ISEDITTEMPLATE
} from './mmNewRequestAction';

const initialState = {

    sourceDropdownValue: 'Select Source',
    reasonCodeDropdownValue: 'Select Reason Code',
    templateDropdownValue: '',
    urgencyDropdownValue: 'Select Urgency',
    noOFRecipientDropdownValue: 'Select Number of Recipients',
    resonInBrief: '',
    isSendApproval: false,
    dlFileName: "Choose Distribution List",
    isAddTemplate: false,
    selectedDlFile: "",
    isEditTemplate: false

};
const massMailerCommonSearch = (state = initialState, action) => {
    switch (action.type) {
        case SET_SOURCEDROPDOWNVALUE:
            return Object.assign({}, state, {
                sourceDropdownValue: action.value
            })
        case SET_REASONCODEDROPDOWNVALUE:
            return Object.assign({}, state, {
                reasonCodeDropdownValue: action.value
            })
        case SET_TEMPLATEDROPDOWNVALUE:
            return Object.assign({}, state, {
                templateDropdownValue: action.value
            })
        case SET_URGENCYDROPDOWNVALUE:
            return Object.assign({}, state, {
                urgencyDropdownValue: action.value
            })
        case SET_REASONINBRIEF:
            return Object.assign({}, state, {
                resonInBrief: action.value
            })
        case SET_NOOFRECIPIENTDROPDOWNVALUE:
            return Object.assign({}, state, {
                noOFRecipientDropdownValue: action.value
            })
        case SET_ISSENDAPPROVAL:
            return Object.assign({}, state, {
                isSendApproval: action.value
            })
        case SET_DLFILENAME:
            return Object.assign({}, state, {
                dlFileName: action.value
            })
        case SET_SELECTEDDLFILE:
            return Object.assign({}, state, {
                selectedDlFile: action.value
            })
        case SET_ISADDTEMPLATE:
            return Object.assign({}, state, {
                isAddTemplate: action.value
            })
        case SET_ISEDITTEMPLATE:
            return Object.assign({}, state, {
                isEditTemplate: action.value
            })
        default:
            return state;
    }
}
export default massMailerCommonSearch;